import { useMemo } from 'react';
import { FiservCardInterface, FiservCardStatusEnum } from '@common-fe/common-fe';

import { useGetCardsQuery } from '../queries/useGetCards.query';

interface Args {
  employeeId?: string | null;
  cardId?: string | null;
}

export default (args: Args) => {
  const { employeeId, cardId } = args;
  const {
    isLoading,
    refetch,
    cardMap,
  } = useGetCardsQuery(employeeId);

  const card = useMemo(() => Object.keys(cardMap)
    .reduce((cardList, holderName) => [
      ...cardList,
      ...Object.values(cardMap[holderName])
        .reduce(
          (arr, status) => [...arr, ...status],
          [] as FiservCardInterface[],
        ),
    ], [] as FiservCardInterface[])
    .find((item) => `${item.id}` === cardId),
  [cardMap, cardId]);

  const preparedCard = useMemo(() => ({
    status: card?.status as FiservCardStatusEnum,
    last4Number: card?.last4Number || '',
    holder: card?.holder || {},
    id: `${card?.id}`,
    bankType: card?.bankType,
    primary: !!card?.primary,
    expDate: card?.expDate,
    cardRequestDate: card?.cardRequestDate,
    mailedDate: card?.mailedDate,
    activationDate: card?.activationDate,
    cardAccountId: card?.cardAccountId,
    cardPurses: card?.cardPurses,
    employeeUnlockForbidden: card?.employeeUnlockForbidden,
  }), [card]);
  return {
    card: preparedCard as FiservCardInterface,
    isLoading,
    refetch,
  };
};
